<template>
  <div class="vf-form">
    <input type="hidden" name="FormResponseId" :value="_formResponseId" />
    <div v-for="field in fields">
      <TextField :field="field" :editMode="editMode" v-if="field.dataType === 'Text'" />
      <DateTimeField :field="field" :editMode="editMode" v-if="field.dataType === 'DateTime'" />
      <MultipleChoiceField :field="field" :editMode="editMode" v-if="field.dataType === 'MultipleChoice'" />
      <FileField :field="field" :propertyId="propertyId" :formId="formId" :formResponseId="_formResponseId" :ensureFormResponse="ensureFormResponse" :editMode="editMode" v-if="field.dataType === 'File'" />
      <TitleDescriptionField :field="field" :editMode="editMode" v-if="field.dataType === 'TitleDescription'" />
    </div>
  </div>
</template>
  
<script>
  import formApi from '../../api/form-api.js';
  import _ from "lodash";
  import TextField from './Renderer/TextField.vue';
  import DateTimeField from './Renderer/DateTimeField.vue';
  import MultipleChoiceField from './Renderer/MultipleChoiceField.vue';
  import FileField from './Renderer/FileField.vue';
  import TitleDescriptionField from './Renderer/TitleDescriptionField.vue';
  import { validate } from 'uuid';

  let submitEventHandler = null;
  let parentForm = null;

  export default {
    name: 'form-renderer',

    components: {
      DateTimeField,
      TextField,
      MultipleChoiceField,
      FileField,
      TitleDescriptionField
    },

    props: {
      formId : {
        type: Number,
        required: true
      },
      propertyId : {
        type: Number,
        required: true
      },
      formResponseId :{
        type: Number,
        required: false
      },
      editMode : {
        type: Boolean,
        required: true
      }
    },

    data(){
      return {
        _formResponseId : this.formResponseId,
        formVersionId : null,
        formName : null,
        fields : null,
        errorMessages : [],
        loaded: false,
        savingChanges: false
      }
    },

    async mounted(){
      parentForm = this.$el.parentElement.closest('form');
      
      //parentForm.addEventListener('submit', this.onSubmit);

      if(this._formResponseId){
        const formResponse = await formApi.getFormResponse(this.formId, this._formResponseId);

        this.fields = formResponse.data.fields;
        this.formVersionId = formResponse.data.formVersionId;
      }else{
        const form = await formApi.getForm(this.formId);

        this.formVersionId = form.data.formVersionId;
        this.fields = form.data.fields;
      }

      this.fields = this.fields.sort((a, b) => {
        return a.ordinal - b.ordinal;
      });

      this.loaded = true;
    },

    async unmounted(){
      parentForm.removeEventListener('submit', this.onSubmit);
    },

    computed : {

    },

    methods : {
      onSubmit: function(event){
        if(!this.editMode){
          return;
        }

        this.validateForm();

        if(this.savingChanges){
          this.errorMessages.push('Still saving changes. Please retry in a few seconds.');
        }

        if(this.errorMessages.length > 0){
          event.preventDefault();
          return;
        }
      },

      queueSaveChanges: function() {
        if(!this.editMode){
          return;
        }

        if (this.saveTimeoutId) {
          console.log('clearing timeout');
          clearTimeout(this.saveTimeoutId);
        }

        this.saveTimeoutId = setTimeout(() => {
          console.log('Saving changes');
          this.saveTimeoutId = null;
          this.saveChanges();
        }, 1500);
      },

      async ensureFormResponse() {
        if (this._formResponseId) {
          return;
        }
        await this.saveChanges();
      },

      async saveChanges(){
        if(!this.editMode){
          return;
        }

        let response = null;
        this.savingChanges = true;

        try{
          
          response = await formApi.postFormResponse(this.formId, this._formResponseId, {
            formVersionId: this.formVersionId,
            fields : this.fields
          });
        }catch(ex){
          this.savingChanges = false;
          this.errorMessages.push(ex.response.data.message);
          return;
        }

        this.savingChanges = false;

        // Get our new id and set it locally
        this._formResponseId = response.data.formResponseId;
      },

      validateForm(){

      }
    },

    watch : {
      fields: {
        handler(newValue, oldValue) {
          // If this is an initialization, ignore it.
          if(oldValue == null){
            return;
          }

          if(!this.loaded){
            return;
          }

          this.validateForm();

          this.queueSaveChanges();

        },
        deep: true
      }
    }
  }
</script>
  
<style lang="scss">
  .vf-form{
    .vf-form-field{
      margin-bottom: 1.5rem;


      &-description{
        color: #666;
        margin-top: 0.25rem;
      }
    }
  }
</style>
<style lang="scss" scoped>
 
</style>